/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetIntegrationsResponse } from '../../models/get-integrations-response';

export interface GetIntegrations$Params {
}

export function getIntegrations(http: HttpClient, rootUrl: string, params?: GetIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetIntegrationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getIntegrations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetIntegrationsResponse>;
    })
  );
}

getIntegrations.PATH = '/integrations';
